import { useNavigate } from "react-router-dom";

interface Props {
  label: string;
  icon;
  value: number;
  color: string;
  route: string;
}

const StatCard = ({label, icon, value, color, route}: Props) => {

  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(route)}
      className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-start justify-between transition-all duration-300 cursor-pointer hover:shadow-xl hover:-translate-y-1 active:scale-95 hover:border-emerald-200"
    >
      <div className="flex-1">
        <p className="text-sm font-medium text-slate-500 uppercase tracking-wider">
          {label}
        </p>
        <h3 className="text-3xl font-bold text-slate-900 mt-1">{value}</h3>
      </div>
      <div
        className={`p-4 rounded-xl ${color} bg-opacity-10 text-2xl flex items-center justify-center shrink-0`}
      >
        {icon}
      </div>
    </div>
  );
}

export default StatCard